type Options = { autoRedirect?: boolean };

export default async <T>(
  action: () => Promise<T>,
  options?: Options,
): Promise<ResultWithData<T>> => {
  const router = useRouter();
  try {
    const value = await action();
    return { success: true, data: value };
  } catch (error) {
    // Error, we're not authenticated
    console.log("[AuthRequest] Error: " + error);
    if (options?.autoRedirect ?? true) {
      router.push(`/admin/login?from=${router.currentRoute.value.fullPath}`);
    }
    return { success: false, error };
  }
};

export const getAuthenticatedRedirectTarget = (
  from: string | (string | undefined | null)[] | undefined | null,
) => {
  if (from === undefined || from === null) {
    return "/admin/events";
  }
  if (typeof from === "string") {
    return decodeURIComponent(from);
  }
  if (from.length < 1 || from[0] === undefined || from[0] === null) {
    return "/admin/events";
  }
  return decodeURIComponent(from[0]);
};
